import {
  GalleryRow,
  ModalOpenButton,
  TypographyWithMaxNumberOfLines,
  useFormatting,
} from "@msys/ui";
import { Box, ButtonBase, Divider, Stack, Typography } from "@mui/material";
import { ClientInputModal } from "./ClientInputModal.js";
import { ClientInput } from "./types.js";
import { useClientInputAttachments } from "./useClientInputAttachments.js";

const COMMENT_PREVIEW_LINES = 1;
const THUMBNAIL_SIZE = 72;
const LIST_PADDING = 2;

export const ClientInputsList = ({
  clientInputs,
}: {
  clientInputs: ClientInput[];
}) => {
  return (
    <Stack
      direction="column"
      divider={<Divider flexItem />}
      sx={{ padding: LIST_PADDING, overflowX: "hidden" }}
    >
      {clientInputs.map(clientInput => (
        <ClientInputEntry key={clientInput.id} clientInput={clientInput} />
      ))}
    </Stack>
  );
};

const ClientInputEntry = ({ clientInput }: { clientInput: ClientInput }) => {
  const { getFormattedDateTime } = useFormatting();
  const { images } = useClientInputAttachments(clientInput);

  return (
    <ModalOpenButton Modal={ClientInputModal} modalProps={{ clientInput }}>
      {/* Negative margin cancels the list padding so the ripple reaches the
          card edges; the equal padding keeps the content on the dividers. */}
      <ButtonBase
        sx={{
          justifyContent: "flex-start",
          textAlign: "left",
          marginX: -LIST_PADDING,
          paddingX: LIST_PADDING,
          paddingY: 1,
        }}
      >
        <Stack
          direction="row"
          spacing={1.5}
          sx={{
            width: "100%",
            alignItems: "center",
            minHeight: THUMBNAIL_SIZE,
          }}
        >
          {images.length > 0 && (
            <Box sx={{ width: THUMBNAIL_SIZE, flexShrink: 0 }}>
              <GalleryRow
                images={images}
                maxItems={1}
                imageHeight={THUMBNAIL_SIZE}
              />
            </Box>
          )}

          <Stack direction="column" spacing={0.5} sx={{ minWidth: 0, flex: 1 }}>
            {clientInput.commentText && (
              <TypographyWithMaxNumberOfLines
                variant="body2"
                $maxLines={COMMENT_PREVIEW_LINES}
              >
                {clientInput.commentText}
              </TypographyWithMaxNumberOfLines>
            )}

            <Typography variant="caption" color="text.secondary">
              {getFormattedDateTime(new Date(clientInput.createdAt))}
            </Typography>
          </Stack>
        </Stack>
      </ButtonBase>
    </ModalOpenButton>
  );
};
